import { EventEmitter, Injectable, Output } from '@angular/core';
import { FiniteStateMachineModalComponent } from 'src/app/shared/modals/finite-state-machine-modal/finite-state-machine-modal.component';
import { FiniteStateMachineModel } from '../../models/finiteStateMachines/finite-state-machine.model';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FiniteStateMachineModalService {

  @Output() modelChanged = new EventEmitter<any>(); 
  
  constructor(  private modalService: NgbModal) { }

  openModal(model?: FiniteStateMachineModel) {
    var modalRef!: NgbModalRef;

    if(model == null){
      model = new FiniteStateMachineModel(); 
    }

    modalRef = this.modalService.open( FiniteStateMachineModalComponent, { windowClass : "customModalClassUnderName",size: 'lg', centered: false, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.model = {...model}; 
    var sub: Subscription = modalRef.closed.subscribe(()=>{
      this.modelChanged.emit(modalRef.componentInstance.model);
      sub.unsubscribe();
    })
  }
}
